export const API_URL = "https://ssl.a-flying.com";
//export const API_URL = "http://192.168.42.198";
export const API_PORT = 8093;
